<template>
    <component
        :is="tag"
        class="flex items-center rounded-full border border-divider bg-surface--elevated px-1.5 py-0.5 text-sm"
        :data-spec-class="dataSpecClass"
    >
        <component
            :is="icon"
            v-if="icon"
            class="mr-2 h-4 w-4 shrink-0"
        />

        <span
            :class="[
                truncate ? 'min-w-0 truncate' : '',
                click ? 'cursor-pointer underline transition-ease hover:text-muted' : '',
            ]"
            data-spec-class="tag__text"
            @click="click"
        >
            <slot />
        </span>

        <a
            v-if="remove"
            class="ml-auto flex shrink-0 items-center justify-center"
            data-spec-class="tag__delete"
            @click.prevent="remove"
        >
            <XCircleIcon
                class="ml-2 h-5 w-5 cursor-pointer text-tertiary transition-ease hover:text-muted"
            />
        </a>
    </component>
</template>

<script lang="ts" setup>
import { XCircleIcon } from '@heroicons/vue/20/solid';
import type { Component } from 'vue';

interface Props {
    tag?: string;
    icon?: Component;
    click?: () => void;
    remove?: () => void;
    truncate?: boolean;
    dataSpecClass?: string;
}

withDefaults(defineProps<Props>(), {
    tag: 'li',
    icon: undefined,
    click: undefined,
    remove: undefined,
    truncate: false,
    dataSpecClass: 'tag',
});
</script>
